<div
  class="fixed bottom-0 left-0 z-10 block w-full border-t bg-white text-gray-500 md:hidden"
  *ngIf="mobileLayoutConfig.bottomNav.visibillity">
  <div class="grid grid-cols-5">
    <ng-container *ngFor="let nav of navs">
      <a
        *ngIf="nav.link"
        class="p-3 py-2 text-center"
        [routerLink]="[nav.link]"
        [queryParams]="nav.queryParams"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="text-primary-md-dark font-medium">
        <img
          class="mx-auto aspect-square w-6"
          [src]="nav.iconImage"
          alt="icon" />
        <h3 class="text-xs">{{ nav.name }}</h3>
      </a>
      <a
        *ngIf="nav.anchor"
        class="p-3 py-2 text-center"
        [href]="nav.anchor"
        target="_blank">
        <img
          class="mx-auto aspect-square w-6"
          [src]="nav.iconImage"
          alt="icon" />
        <h3 class="text-xs">{{ nav.name }}</h3>
      </a>
    </ng-container>
  </div>
</div>
